import { Banner } from "@newsela/angelou";
import { capitalize } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import AUTH_PROVIDER_NAME_TRANSFORMATIONS from "@/constants/AUTH_PROVIDER_NAME_TRANSFORMATIONS";

const propTypes = {
  provider: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const ClassroomLastSyncFailedBanner = ({ provider, onClose }) => {
  return (
    <Banner
      bannerType={Banner.types.alert}
      title={`${AUTH_PROVIDER_NAME_TRANSFORMATIONS[provider] || capitalize(provider)} last sync failed`}
      body="Please try again or contact Newsela support."
      onClose={onClose}
      isDismissible
    />
  );
};

ClassroomLastSyncFailedBanner.propTypes = propTypes;

export default ClassroomLastSyncFailedBanner;
